export default __webpack_public_path__ + "static/media/landing_thumb_03.c9df5163.svg";